var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKenya(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0C7.24218 0 3.13143 2.76867 1.19043 6.78263H22.8089C20.868 2.76867 16.7572 0 11.9997 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24C7.24218 24 3.13143 21.2314 1.19043 17.2174H22.8089C20.868 21.2314 16.7572 24 11.9997 24Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 8.34778H0.566672C0.199078 9.49945 0 10.7264 0 11.9999C0 13.2735 0.199078 14.5004 0.566672 15.6521H23.4333C23.8009 14.5004 24 13.2735 24 11.9999C24 10.7264 23.8009 9.49945 23.4333 8.34778Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.737 5.54533L14.3158 4.8894L12.0003 10.1324L9.68478 4.8894L8.26367 5.54533L11.1384 12L8.26367 18.4546L9.68478 19.1105L12.0003 13.8675L14.3158 19.1105L15.737 18.4546L12.8622 12L15.737 5.54533Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9656 6.16346C12.4154 5.56266 12.0004 5.21729 12.0004 5.21729C12.0004 5.21729 11.5853 5.56261 11.0352 6.16346V17.8363C11.5853 18.4372 12.0004 18.7825 12.0004 18.7825C12.0004 18.7825 12.4154 18.4372 12.9656 17.8363V6.16346Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3916 8.40202V15.5979C9.97295 16.628 10.6845 17.4723 11.2177 18.0321V5.9679C10.6845 6.52763 9.9729 7.37199 9.3916 8.40202Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6093 8.40202C14.0279 7.37194 13.3165 6.52763 12.7832 5.9679V18.0321C13.3164 17.4723 14.0279 16.628 14.6093 15.5979V8.40202Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 8.40198V15.5979C15.1969 14.5549 15.6519 13.3217 15.6519 12C15.6519 10.6782 15.1969 9.44495 14.6084 8.40198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39114 8.40198V15.5979C8.80263 14.5549 8.34766 13.3217 8.34766 12C8.34766 10.6782 8.80263 9.44495 9.39114 8.40198Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/99a94b9d.svg";
export { SvgKenya as ReactComponent };